module.exports = __webpack_public_path__ + "static/developer-website-seo-image-ebc45880871ddf7830c1ec2a5c5932e3.png";